import angular from 'angular';

import Component from './date-picker.component';

const Module = angular
    .module('control-room.commons.basic.components.date-picker', [])
    .component('crDatePicker', Component);

export default Module;
